import { RouteEnum } from "./constant";

export class Utility {
  static generateAmazonAffiliateUrl(amazonUrl: string, title: string) {
    if (!amazonUrl) return "/";

    try {
      const url = new URL(amazonUrl);

      // Extract domain (e.g., www.amazon.com, www.amazon.in)
      const domain = url.hostname;

      // Extract ASIN from URL
      const asinMatch = url.pathname.match(/dp\/([A-Z0-9]+)/);
      if (!asinMatch) throw new Error("Invalid Amazon URL");

      const asin = asinMatch[1]; // Extracted ASIN

      // Extract affiliate tag from URL
      const affiliateTag = url.searchParams.get("tag") || "";
      if (!affiliateTag) throw new Error("Affiliate tag missing in URL");

      // Create SEO-friendly slug from title
      const slug = title
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-") // Replace spaces & special chars with "-"
        .replace(/^-+|-+$/g, ""); // Trim leading & trailing "-"

      // Base64 encode the affiliate tag
      // const encodedTag = Buffer.from(affiliateTag).toString("base64");

      // Construct final Amazon URL
      return `https://${domain}/dp/${asin}/${slug}?tag=${affiliateTag}`;
    } catch (error) {
      console.log("Error generating Amazon affiliate URL:", error);
      return null;
    }
  }

  static getRouteLinkUrl({
    tools = "/tools",
    main,
    blog,
    pathname,
  }: {
    main: string;
    blog: string;
    pathname: string;
    tools?: string;
  }) {
    const route = this.getRouterPlatformName(pathname);

    if (route === RouteEnum.BLOG) {
      return blog;
    } else if (route === RouteEnum.TOOLS) {
      return tools;
    } else {
      return main;
    }
  }

  static getRouterPlatformName(pathname: string): RouteEnum {
    if (pathname.startsWith("/blog")) {
      return RouteEnum.BLOG;
    } else if (pathname.startsWith("/tools")) {
      return RouteEnum.TOOLS;
    } else {
      return RouteEnum.MAIN;
    }
  }

  ///==========Product url
  static extractAsinFromUrl = (url: string) => {
    const match = url.match(/(?:dp|gp\/product)\/([A-Z0-9]{10})/i);
    return match ? match[1] : null;
  };

  static isValidAmazonUrl = (url: string) => {
    return /amazon\./i.test(url) && this.extractAsinFromUrl(url) !== null;
  };

  static generateAffiliateLink = (
    asin: string,
    domain: string,
    tag?: string,
    title?: string,
  ) => {
    const baseUrl = `https://${domain}/dp/${asin}/starlightopia-${title || ""}`;
    // return tag ? `${baseUrl}/?tag=${tag}` : baseUrl;
    return {
      affiliateUrl: tag ? `${baseUrl}/?tag=${tag}` : baseUrl,
      baseUrl: baseUrl,
    };
  };
}
